import axios from "axios";
export const httpGetRequest = (params) => {
    //select,address,
    params = params || {}
    let app_url2 = 'https://zjnb.720pai.cn/api2';
    let app_url = 'https://zjnb.720pai.cn/api';

    if (params.route === 1) {
        params.url = app_url + params.url
    }
    if (params.route === 2) {
        params.url = app_url2 + params.url
    }
    return new Promise(function (resolve, reject) {
        axios.get(params.url, { "params": params.data })
            .then(function (response) {
                resolve(response.data)
            })
            .catch(function (error) {
                reject(error.data)
            })
    })
}